import React from 'react';

import T from '../../../nls/translate.js';
import '../../../nls/translate-info.js';

// TODO table mit padding left und right, sowei top und bottom (letzteres größer), td mit preformated Zeilenumbruch

export default function (hideCallback) {
	const p3k7 = '3'+T.current.MATH.FRACTION+'7kW';
	return (
		<div className="slx-stele-options__dummy slx-charginginfo">
			<div className="slx-stele-options__dummy slx-charginginfo__whiteBox">
				<table>
					<tbody>
					<tr className="slx-charginginfo__line">
						<td>&nbsp;</td>
						<td>{T.current.INFO.CHARGING_BASIC}</td>
						<td>{T.current.INFO.CHARGING_ADV}</td>
						<td>{T.current.INFO.CHARGING_PROF}</td>
					</tr>

					<tr>
						<td>{T.current.INFO.POWER}</td>
						<td>{p3k7}</td>
						<td>{p3k7}</td>
						<td>{p3k7}</td>
					</tr>
					<tr>
						<td>&nbsp;</td>
						<td>11kW</td>
						<td>11kW</td>
						<td>11kW</td>
					</tr>
					<tr  className="slx-charginginfo__line">
						<td>&nbsp;</td>
						<td>22kW</td>
						<td>22kW</td>
						<td>22kW</td>
					</tr>

					<tr  className="slx-charginginfo__line">
						<td>{T.current.INFO.EQUIPMENT}</td>

						<td>{T.current.INFO.EQUIPMENT_BASIC}</td>
						<td>{T.current.INFO.EQUIPMENT_ADV}</td>
						<td>{T.current.INFO.EQUIPMENT_PROF}</td>
					</tr>
					<tr>
						<td colSpan="4">{T.current.INFO.EXLPANATION}</td>
					</tr>
					</tbody>
				</table>
				<div className="slx-stele-options__dummy slx-charginginfo__ok" onClick={hideCallback} role="button">
					{T.current.INFO.OK}
				</div>
			</div>
		</div>
	);
}
